import { inject } from 'mobx-react';
import * as React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { DefaultBranch, IBranch } from 'src/Definitions';
import { IStores } from 'src/Stores';
import BranchDialog from './BranchDialog';

interface IBranchesProps {
    dataTableManager?: IDataTableManager<IBranch>;
    disableBranch?: (branch: IBranch) => void;
    getColumnSettingsAndBranches?: () => void;
    isModalOpen?: boolean;
    openDialogWithBranch?: (branch: IBranch) => void;
    recoverBranch?: (branch: IBranch) => void;
}

@inject((stores: IStores) => ({
    dataTableManager: stores.branches.dataTableStore,
    disableBranch: stores.branches.disableBranch,
    getColumnSettingsAndBranches: stores.branches.getColumnSettingsAndBranches,
    isModalOpen: stores.branches.isModalOpen,
    openDialogWithBranch: stores.branches.openDialogWithBranch,
    recoverBranch: stores.branches.recoverBranch,
}))
class Branches extends React.Component<IBranchesProps> {
    public componentDidMount() {
        this.props.getColumnSettingsAndBranches!();
    }

    public render() {
        const branchDialog = this.props.isModalOpen && <BranchDialog />;
        return (
            <>
                <ESDataTableWithHeader
                    dataTableManager={this.props.dataTableManager!}
                    enableEdit={true}
                    enableReorderColumns={true}
                    enableSearch={true}
                    enableShowInactives={true}
                    enableToggleColumns={true}
                    openDialog={this.openDialog(DefaultBranch(true))}
                    title="Branches"
                />
                {branchDialog}
            </>
        );
    }

    public openDialog = (branch: IBranch) => () => {
        this.props.openDialogWithBranch!(branch);
    };
}

export default Branches;



// WEBPACK FOOTER //
// ./src/branches/Branches.tsx